module.exports = __webpack_public_path__ + "img/logo_isolutions.cae5cd91.png";